import axiosInstance from './AxiosInstance';

export function fetchPartnerDetails(partnerId) {
  return axiosInstance.get(`partners/${partnerId}`);
}

export function fetchPartnerUsers(
  partnerId,
  page = 1,
  search = '',
  role = '',
  status = '',
  perPage = null,
  teamId = '',
) {
  const params = { page };
  if (search)  params.search  = search;
  if (role)    params.role    = role;
  if (status)  params.status  = status;
  if (teamId)  params.team_id = teamId;
  if (perPage !== null) params.per_page = perPage;
  return axiosInstance.get(`partners/${partnerId}/users`, { params });
}

export function registerPartnerUser(partnerId, data) {
  return axiosInstance.post(`partners/${partnerId}/users`, data);
}

export function registerPartner(data) {
  return axiosInstance.post('partners', data);
}

export function updatePartner(partnerId, data) {
  return axiosInstance.put(`partners/${partnerId}`, data);
}

export function addPartnerTeams(partnerId, data) {
  return axiosInstance.post(`partners/${partnerId}/teams`, data);
}

export function getPartnerTeams(partnerId, page = 1, perPage = null) {
  const params = { page };
  if (perPage !== null) params.per_page = perPage;
  return axiosInstance.get(`partners/${partnerId}/teams`, { params });
}

export function getAllPartnerTeams(partnerId) {
  return axiosInstance.get(`partners/${partnerId}/teams/all`);
}

export function getActivePartnerUserCount(partnerId) {
  return axiosInstance.get(`partner/${partnerId}/count-active-users`);
}

export function fetchAllPartners({ page = 1 } = {}) {
  return axiosInstance.get('partners', { params: { page } });
}

export function updateUserGroup(partnerId, teamId, data) {
  return axiosInstance.put(`partners/${partnerId}/teams/${teamId}`, data);
}

export function fetchUserGroup(partnerId, teamId) {
  return axiosInstance.get(`partners/${partnerId}/teams/${teamId}`);
}

export function fetchPossibleTeamReviewers(partnerId) {
  return axiosInstance.get(`partners/${partnerId}/possible-team-reviewers`);
}

export function addReviewer(partnerId, teamId, data) {
  return axiosInstance.post(`partners/${partnerId}/teams/${teamId}/add-reviewer`, data);
}

export function unassignReviewer(partnerId, teamId, reviewerId) {
  return axiosInstance.delete(`partners/${partnerId}/teams/${teamId}/reviewers/${reviewerId}`);
}

export function deletePartnerTeam(partnerId, teamId) {
  return axiosInstance.delete(`partners/${partnerId}/teams/${teamId}`);
}

export function getTeamDeletePreview(partnerId, teamId) {
  return axiosInstance.get(`partners/${partnerId}/teams/${teamId}/delete-preview`);
}

export function deactivatePartner(partnerId) {
  return axiosInstance.post(`partners/${partnerId}/deactivate`);
}
